import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";


export default function SidebarLayout(props) {
  return <> <DashboardHeader />
    <section className="user-dashboard user-new-dash">
      <div className="container">
        {props.children}
      </div>
    </section>
    <Footer /></>;
}
